// Teste de upload para produção
// Execute no console do navegador: testProductionUpload()

interface SupabaseConfig {
  url: string;
  anonKey: string;
}

interface UploadResult {
  success: boolean;
  url?: string;
  error?: string;
}

// Função para testar upload em produção
window.testProductionUpload = async (): Promise<UploadResult> => {
  console.log('🧪 Testando upload em produção...');
  
  try {
    // Verificar se as variáveis de ambiente estão disponíveis
    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
    const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
    
    console.log('🔧 Configurações:', {
      url: supabaseUrl,
      keyLength: supabaseKey?.length || 0
    });
    
    if (!supabaseUrl || !supabaseKey) {
      throw new Error('Variáveis de ambiente do Supabase não encontradas');
    }
    
    // Criar um arquivo de teste pequeno
    const testContent = 'Teste de upload em produção - ' + new Date().toISOString();
    const testFile = new File([testContent], 'test-production.txt', {
      type: 'text/plain'
    });
    
    console.log('📁 Arquivo de teste criado:', {
      name: testFile.name,
      size: testFile.size,
      type: testFile.type
    });
    
    // Fazer upload usando fetch diretamente para a API do Supabase
    const timestamp = Date.now();
    const fileName = `test-production-${timestamp}.txt`;
    const filePath = `products/files/${fileName}`;
    
    console.log('📤 Fazendo upload para:', filePath);
    
    const uploadUrl = `${supabaseUrl}/storage/v1/object/files/${filePath}`;
    
    const response = await fetch(uploadUrl, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${supabaseKey}`,
        'Content-Type': testFile.type,
        'x-upsert': 'false'
      },
      body: testFile
    });
    
    console.log('📊 Resposta do upload:', {
      status: response.status,
      statusText: response.statusText
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ Erro no upload:', errorText);
      throw new Error(`Upload falhou: ${response.status} - ${errorText}`);
    }
    
    // Obter URL pública
    const publicUrl = `${supabaseUrl}/storage/v1/object/public/files/${filePath}`;
    
    console.log('✅ Upload concluído com sucesso!');
    console.log('🔗 URL pública:', publicUrl);
    
    // Testar se o arquivo é acessível
    const testAccess = await fetch(publicUrl);
    console.log('🔍 Teste de acesso:', {
      status: testAccess.status,
      accessible: testAccess.ok
    });
    
    return {
      success: true,
      url: publicUrl
    };
    
  } catch (error) {
    console.error('❌ Erro no teste:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Erro desconhecido'
    };
  }
};

// Declarar a função globalmente
declare global {
  interface Window {
    testProductionUpload: () => Promise<UploadResult>;
  }
}

export {};